// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3RAYb","inner":"Footer_inner__1c35E"};